import { createSlice } from '@reduxjs/toolkit';
import { IFailedPayload } from 'redux/types/Call.types';

export interface AgencyVisitState {
  error: IFailedPayload | null;
  loading: boolean;
  message: string;
}

export const agencyVisitInitialState: AgencyVisitState = {
  error: null,
  loading: false,
  message: '',
};

const agencyVisitSlice = createSlice({
  name: 'compliance/agency-visit',
  initialState: agencyVisitInitialState,
  reducers: {
    sayHello: (state) => {
      state.message = 'Hello';
    },
  },
});

export const { sayHello } = agencyVisitSlice.actions;

export default agencyVisitSlice.reducer;
